// ReturnMetricCard — one return-metric cell in the Portfolio summary bar
// (Today / MTD / YTD return / 1-year return). Source of truth: portfolio3.css
// .pf3-cell. Pure-presentational: label + signed % (green/red) + signed $ amount.
import PropTypes from 'prop-types';
import { cx } from '../../../../utils/cx';
import { formatCurrency, formatPercent } from '../../../../utils/format';
import { TrendIcon } from '../../../icons/Icons';
import './return-metric-card.css';

export function ReturnMetricCard({ label, shortLabel, pct, amount, digits = 1, showArrow = false }) {
  const gain = (pct ?? 0) >= 0;
  const tone = gain ? 'gain' : 'loss';
  const amountText = `${gain ? '+' : ''}${formatCurrency(amount)}`;

  return (
    <div className={cx('return-metric-card', `return-metric-card--${tone}`)}>
      <span className="return-metric-card__label">
        <span className="return-metric-card__label-full">{label}</span>
        <span className="return-metric-card__label-short">{shortLabel || label}</span>
      </span>
      <span className="return-metric-card__value">
        {showArrow && gain && <TrendIcon aria-hidden="true" />}
        {formatPercent(pct, { digits, signed: true })}
      </span>
      <span className="return-metric-card__sub">{amountText}</span>
    </div>
  );
}

ReturnMetricCard.propTypes = {
  label: PropTypes.string.isRequired,
  /** Compact label shown at ≤600px (e.g. "YTD", "1Y"). */
  shortLabel: PropTypes.string,
  pct: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  /** Decimal places on the percentage (Today shows 2, the rest 1). */
  digits: PropTypes.number,
  /** Show the up-trend glyph before the value (design: Today only). */
  showArrow: PropTypes.bool,
};

export default ReturnMetricCard;
